var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "buyer-button relative font-bold text-lg md_text-sm border-2 border-transparent",
      class: _vm.classes,
      style: { color: _vm.textColor },
      attrs: { type: _vm.type || "button", disabled: _vm.disabled },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        },
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.text))]),
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.processing,
            expression: "processing"
          }
        ],
        staticClass: "loader w-2 h-2 absolute border-2 border-white rounded-4"
      }),
      _vm.type !== "submit"
        ? _c("div", {
            staticClass:
              "absolute border h-full w-full buyer-button__border border-inherit"
          })
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }